module.exports = __webpack_public_path__ + "static/img/ARADIN1_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARADIN1_2.png
// module id = H0Jo
// module chunks = 0